


















import Vue from 'vue';
import Component from 'vue-class-component';
import LayoutService from '@/services/LayoutService';

@Component({})
export default class MimityLayout extends Vue {
  protected created() {
    LayoutService.mimity();
  }
}
